import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { refreshImportStatus } from './store/actions/ui';

export class ImportStatus extends React.Component {
  static propTypes = {
    importStatus: PropTypes.array.isRequired,
    refreshImportStatus: PropTypes.func.isRequired
  }

  componentDidMount() {
    const { importStatus, refreshImportStatus } = this.props;
    this.timer = setInterval(() => refreshImportStatus(importStatus), 5000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
    this.timer = null;
  }

  render() {
    return null;
  }
}

const mapDispatchToProps = {
  refreshImportStatus
};

export default connect(() => ({}), mapDispatchToProps)(ImportStatus);
